import React, { createContext, useContext, useState } from 'react';

const translations = {
  es: {
    // Header
    search: 'Buscar excursiones...',
    noResults: 'No se encontraron excursiones',
    viewAll: 'Ver todas las excursiones',
    cart: 'Carrito',
    cartEmpty: 'Tu carrito está vacío',
    cartNote: 'Las reservaciones se realizan por WhatsApp',
    close: 'Cerrar',
    nosotros: 'Nosotros',
    contacto: 'Contacto',
    inicio: 'Inicio',
    traslados: 'Traslados',
    excursiones: 'Excursiones',
    villas: 'Reservación de Villas',
    allTours: 'Todas las Excursiones',
    priceFrom: 'desde',
    
    // Hero
    heroTitle: 'REPÚBLICA DOMINICANA, LO TIENE TODO',
    heroSubtitle: 'Descubre las mejores excursiones y tours en Punta Cana',
    heroButton: 'Ver Excursiones',
    
    // Intro
    introTitle: 'Bienvenidos a MR Excursiones',
    introSubtitle: 'Tu mejor opción para explorar Punta Cana',
    introText: 'Somos una empresa dedicada a ofrecer las mejores experiencias turísticas en República Dominicana. Con años de experiencia, te garantizamos tours seguros, divertidos e inolvidables.',
    
    // Tours
    toursTitle: 'Nuestras Excursiones',
    toursSubtitle: 'Descubre las mejores experiencias en Punta Cana',
    perPerson: 'por persona',
    perCouple: 'por pareja',
    children: 'Niños',
    bookNow: 'Reservar Ahora',
    moreInfo: 'Más Información',
    offer: '¡Oferta!',
    from: 'desde',
    
    // Tour Detail
    backToTours: 'Volver a tours',
    duration: 'Duración',
    transport: 'Transporte',
    location: 'Ubicación',
    whatIncludes: 'Qué incluye esta excursión',
    itinerary: 'Itinerario del Tour',
    recommendations: 'Recomendaciones',
    chooseExperience: 'Elige tu experiencia:',
    
    // Destinations
    destinationsTitle: 'Destinos Populares',
    destinationsSubtitle: 'Explora los lugares más increíbles',
    tours: 'tours',
    
    // Testimonials
    testimonialsTitle: 'Lo que dicen nuestros clientes',
    testimonialsSubtitle: 'Experiencias reales de viajeros felices',
    
    // Villas
    villasTitle: 'Reservación de Villas',
    villasSubtitle: 'Alojamiento de lujo para tu estadía',
    villasText: 'Además de excursiones, te ayudamos a encontrar la villa perfecta para tu viaje. Contacta con nosotros para más información.',
    
    // Contact
    contactTitle: 'Contáctanos',
    contactSubtitle: '¿Tienes preguntas? Estamos aquí para ayudarte',
    phone: 'Teléfono',
    email: 'Correo',
    address: 'Dirección',
    whatsapp: 'WhatsApp',
    sendMessage: 'Enviar Mensaje',
    yourName: 'Tu nombre',
    yourEmail: 'Tu correo electrónico',
    yourMessage: 'Tu mensaje',
    
    // Footer
    footerAbout: 'Sobre Nosotros',
    footerAboutText: 'MR Excursiones Punta Cana es tu mejor opción para descubrir la belleza de República Dominicana con tours seguros y experiencias inolvidables.',
    footerLinks: 'Enlaces Rápidos',
    footerContact: 'Contacto',
    footerRights: 'Todos los derechos reservados',
    
    // Reservation Modal
    reservationTitle: 'Reservar',
    reservationName: 'Nombre completo',
    reservationEmail: 'Correo electrónico',
    reservationPhone: 'Teléfono / WhatsApp',
    reservationDate: 'Fecha de la excursión',
    reservationPeople: 'Número de personas',
    reservationAdults: 'Adultos',
    reservationChildren: 'Niños',
    reservationNotes: 'Notas adicionales',
    reservationSubmit: 'Enviar por WhatsApp',
    reservationCancel: 'Cancelar',
  },
  en: {
    // Header
    search: 'Search tours...',
    noResults: 'No tours found',
    viewAll: 'View all tours',
    cart: 'Cart',
    cartEmpty: 'Your cart is empty',
    cartNote: 'Reservations are made via WhatsApp',
    close: 'Close',
    nosotros: 'About Us',
    contacto: 'Contact',
    inicio: 'Home',
    traslados: 'Transfers',
    excursiones: 'Tours',
    villas: 'Villa Reservations',
    allTours: 'All Tours',
    priceFrom: 'from',
    
    // Hero
    heroTitle: 'DOMINICAN REPUBLIC HAS IT ALL',
    heroSubtitle: 'Discover the best tours and excursions in Punta Cana',
    heroButton: 'View Tours',
    
    // Intro
    introTitle: 'Welcome to MR Excursions',
    introSubtitle: 'Your best option to explore Punta Cana',
    introText: 'We are a company dedicated to offering the best tourist experiences in the Dominican Republic. With years of experience, we guarantee safe, fun and unforgettable tours.',
    
    // Tours
    toursTitle: 'Our Tours',
    toursSubtitle: 'Discover the best experiences in Punta Cana',
    perPerson: 'per person',
    perCouple: 'per couple',
    children: 'Children',
    bookNow: 'Book Now',
    moreInfo: 'More Info',
    offer: 'Sale!',
    from: 'from',
    
    // Tour Detail
    backToTours: 'Back to tours',
    duration: 'Duration',
    transport: 'Transport',
    location: 'Location',
    whatIncludes: 'What this tour includes',
    itinerary: 'Tour Itinerary',
    recommendations: 'Recommendations',
    chooseExperience: 'Choose your experience:',
    
    // Destinations
    destinationsTitle: 'Popular Destinations',
    destinationsSubtitle: 'Explore the most incredible places',
    tours: 'tours',
    
    // Testimonials
    testimonialsTitle: 'What our customers say',
    testimonialsSubtitle: 'Real experiences from happy travelers',
    
    // Villas
    villasTitle: 'Villa Reservations',
    villasSubtitle: 'Luxury accommodation for your stay',
    villasText: 'In addition to excursions, we help you find the perfect villa for your trip. Contact us for more information.',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'Have questions? We are here to help',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    whatsapp: 'WhatsApp',
    sendMessage: 'Send Message',
    yourName: 'Your name',
    yourEmail: 'Your email',
    yourMessage: 'Your message',
    
    // Footer
    footerAbout: 'About Us',
    footerAboutText: 'MR Excursions Punta Cana is your best option to discover the beauty of the Dominican Republic with safe tours and unforgettable experiences.',
    footerLinks: 'Quick Links',
    footerContact: 'Contact',
    footerRights: 'All rights reserved',
    
    // Reservation Modal
    reservationTitle: 'Book',
    reservationName: 'Full name',
    reservationEmail: 'Email',
    reservationPhone: 'Phone / WhatsApp',
    reservationDate: 'Tour date',
    reservationPeople: 'Number of people',
    reservationAdults: 'Adults',
    reservationChildren: 'Children',
    reservationNotes: 'Additional notes',
    reservationSubmit: 'Send via WhatsApp',
    reservationCancel: 'Cancel',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
